// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper_cwZ82","header":"header_akSBA","logo":"logo_KeBYW","controls":"controls_UdLbt"};